import {Component, inject, Input, ViewChild} from '@angular/core';
import {CapitalCasePipe} from "../../../pipes/capital-case.pipe";
import {DxDataGridComponent, DxFormComponent, DxTemplateDirective} from "devextreme-angular";
import {
    DxiButtonComponent,
    DxiColumnComponent,
    DxiItemComponent,
    DxoColumnChooserComponent,
    DxoExportComponent, DxoFilterRowComponent, DxoHeaderFilterComponent, DxoLoadPanelComponent, DxoPagerComponent, DxoPagingComponent,
    DxoScrollingComponent, DxoSortingComponent, DxoToolbarComponent
} from "devextreme-angular/ui/nested";
import {UserAvatarEmailComponent} from "../../../components/utils/user-avatar-email/user-avatar-email.component";
import {
    DataSources, ChangeRequestGridViewDto, PermissionType, AccessType, AuthService, EmailTemplateGridViewDto, NotificationType
} from "@services";
import EnumUtils from "../../../shared/enum-utils";
import {FilterPanelComponent} from "../../../components/library/filter-panel/filter-panel.component";
import {GridPageComponent, FilterConfig} from "../../common/grid-page.component";
import {EmailTemplatePopupComponent} from "./email-template-popup/email-template-popup.component";

@Component({
    selector: 'app-change-requests',
    imports: [
        CapitalCasePipe,
        DxDataGridComponent,
        DxTemplateDirective,
        DxiButtonComponent,
        DxiColumnComponent,
        DxiItemComponent,
        DxoColumnChooserComponent,
        DxoExportComponent,
        DxoFilterRowComponent,
        DxoHeaderFilterComponent,
        DxoLoadPanelComponent,
        DxoPagerComponent,
        DxoPagingComponent,
        DxoScrollingComponent,
        DxoSortingComponent,
        DxoToolbarComponent,
        UserAvatarEmailComponent,
        DxFormComponent,
        FilterPanelComponent,
        EmailTemplatePopupComponent
    ],
    templateUrl: './email-templates.component.html',
    styleUrl: './email-templates.component.scss',
})
export class EmailTemplatesComponent extends GridPageComponent<EmailTemplateGridViewDto> {
    protected dataSources = inject(DataSources);
    protected auth = inject(AuthService);

    constructor() {
        super();
        this.init(ChangeRequestGridViewDto);
    }

    @ViewChild(DxDataGridComponent, {static: true}) dataGrid: DxDataGridComponent;

    @Input() employeeId: string | null = null;

    dataSource = this.dataSources.emailTemplates();
    typeOptions = EnumUtils.getEnumOptions(NotificationType);
    protected override exportName: string = "Email Templates";

    lastModifiedByFilter = this.userNameOrEmailFilter('lastModifiedBy');

    protected override filterConfig: FilterConfig[] = [
        {field: 'type'},
        {field: 'subject', op: 'contains'}
    ];

    protected readonly PermissionType = PermissionType;
    protected readonly AccessType = AccessType;
}
